module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/00cb48b561d398f7e9570ebaeba16211.gif";